export default "__VITE_ASSET__5ba87935__"